import axios from 'axios';
import urls from './urls';
import { IApiResponse } from '../interfaces/IApiResponse';
import { IBoostMySelf } from 'redhotpie-shared-lib/types/boost';

// Define types for the request body
interface PurchaseConsumableBody {
  ConsumablePriceID: string;
  MetaData?: any;
}

class BoostAPI {
  static getUserRemainingInvitesCredit(): Promise<IApiResponse> {
    return axios
      .get<any, IApiResponse>(urls.GET_USER_REMAINING_INVITES_CREDIT, {
        baseURL: urls.BASE_RHPURL,
        headers: { isAnonymous: false },
      })
      .then(res => res);
  }

  static getListInvitesCreditProducts(): Promise<IApiResponse> {
    return axios
      .get<any, IApiResponse>(urls.GET_LIST_INVITES_CREDIT_PRODUCT, {
        baseURL: urls.BASE_RHPURL,
        headers: { isAnonymous: false },
      })
      .then(res => res);
  }
  
  static getListProfileBoostProducts(): Promise<IApiResponse> {
    return axios
      .get<any, IApiResponse>(urls.GET_LIST_PROFILE_BOOST, {
        baseURL: urls.BASE_RHPURL,
        headers: { isAnonymous: false },
      })
      .then(res => res);
  }

  static getListConversationBoostProducts(): Promise<IApiResponse> {
    return axios
      .get<any, IApiResponse>(urls.GET_LIST_CONVERSATION_BOOST, {
        baseURL: urls.BASE_RHPURL,
        headers: { isAnonymous: false },
      })
      .then(res => res);
  }

  static getGenderChangeProduct(): Promise<IApiResponse> {
    return axios
      .get<any, IApiResponse>(urls.GET_PROFILE_CHANGE_PRODUCT, {
        baseURL: urls.BASE_RHPURL,
        headers: { isAnonymous: false },
      })
      .then(res => res);
  }

  static purchaseConsumableProduct(consumableID: string, metaData?: any): Promise<IApiResponse> {
    const body: PurchaseConsumableBody = {
      ConsumablePriceID: consumableID,
    };
    if (metaData) {
      body.MetaData = metaData;
    }
    return axios
      .post<any, IApiResponse>(urls.POST_PURCHASE_CONSUMABLE_PRODUCT, body, {
        baseURL: urls.BASE_RHPURL,
        headers: { isAnonymous: false },
      })
      .then(res => res);
  }

  static async notifyBoostMySelf(body: IBoostMySelf): Promise<IApiResponse> {
    console.log('body', body);
    return await axios.post<any, IApiResponse>(urls.NOTIFY_MYSELF, body, {
      baseURL: urls.BASE_URL,
      headers: { isAnonymous: false },
    });
  }

  static getLikeProducts(): Promise<IApiResponse> {
    return axios
      .get<any, IApiResponse>(urls.GET_LIST_LIKE_PRODUCT, {
        baseURL: urls.BASE_RHPURL,
        headers: { isAnonymous: false },
      })
      .then(res => res);
  }

  static getFavProducts(): Promise<IApiResponse> {
    return axios
      .get<any, IApiResponse>(urls.GET_LIST_FAVS_PRODUCT, {
        baseURL: urls.BASE_RHPURL,
        headers: { isAnonymous: false },
      })
      .then(res => res);
  }
}

export default BoostAPI;
